var _path, _rect, _mask, _path2, _path3, _path4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40913 21.201C2.10131 18.2645 4.7223 16.1897 7.73929 16.19L9.02051 16.1901C12.037 16.1904 14.6572 18.265 15.3494 21.201C15.7465 22.8855 14.4685 24.4998 12.7378 24.4998H4.02073C2.29005 24.4998 1.01206 22.8855 1.40913 21.201Z",
    fill: "#3D218F",
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.15625,
    y: 7.81055,
    width: 6.44828,
    height: 8.31034,
    rx: 3.22414,
    fill: "white",
    stroke: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_731_48",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3286 14.6571C25.376 14.6571 28.6571 11.376 28.6571 7.32857C28.6571 3.28111 25.376 0 21.3286 0C17.2811 0 14 3.28111 14 7.32857C14 8.8302 14.4516 10.2263 15.2265 11.3886L14.5371 12.6215C14.0351 13.5194 15.0529 14.4991 15.931 13.9631L17.0506 13.2796C18.2544 14.1465 19.7318 14.6571 21.3286 14.6571Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3286 14.6571C25.376 14.6571 28.6571 11.376 28.6571 7.32857C28.6571 3.28111 25.376 0 21.3286 0C17.2811 0 14 3.28111 14 7.32857C14 8.8302 14.4516 10.2263 15.2265 11.3886L14.5371 12.6215C14.0351 13.5194 15.0529 14.4991 15.931 13.9631L17.0506 13.2796C18.2544 14.1465 19.7318 14.6571 21.3286 14.6571Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2265 11.3886L16.0993 11.8766L16.3978 11.3428L16.0585 10.8339L15.2265 11.3886ZM14.5371 12.6215L13.6643 12.1335L14.5371 12.6215ZM15.931 13.9631L16.452 14.8166H16.452L15.931 13.9631ZM17.0506 13.2796L17.635 12.4681L17.0962 12.0802L16.5296 12.4261L17.0506 13.2796ZM27.6571 7.32857C27.6571 10.8237 24.8237 13.6571 21.3286 13.6571V15.6571C25.9283 15.6571 29.6571 11.9283 29.6571 7.32857H27.6571ZM21.3286 1C24.8237 1 27.6571 3.8334 27.6571 7.32857H29.6571C29.6571 2.72883 25.9283 -1 21.3286 -1V1ZM15 7.32857C15 3.8334 17.8334 1 21.3286 1V-1C16.7288 -1 13 2.72883 13 7.32857H15ZM16.0585 10.8339C15.3898 9.8308 15 8.62672 15 7.32857H13C13 9.03368 13.5135 10.6219 14.3944 11.9433L16.0585 10.8339ZM15.41 13.1095L16.0993 11.8766L14.3536 10.9006L13.6643 12.1335L15.41 13.1095ZM15.41 13.1095L15.41 13.1095L13.6643 12.1335C12.6602 13.9293 14.6958 15.8886 16.452 14.8166L15.41 13.1095ZM16.5296 12.4261L15.41 13.1095L16.452 14.8166L17.5716 14.1332L16.5296 12.4261ZM21.3286 13.6571C19.9485 13.6571 18.6742 13.2165 17.635 12.4681L16.4662 14.0911C17.8346 15.0765 19.5152 15.6571 21.3286 15.6571V13.6571Z",
    fill: "black",
    mask: "url(#path-3-inside-1_731_48)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3901 5.59018C19.3258 4.88304 19.6601 3.46875 21.5115 3.46875C23.0546 3.46875 23.4403 4.62589 23.4403 5.39732C23.4403 5.78304 23.2475 6.36161 22.2832 6.94018C21.3189 7.51875 21.3189 7.82732 21.3189 8.29018C21.3189 8.75304 21.3189 9.12589 21.3189 9.25446",
    stroke: "#FF7900",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.3266,
    cy: 10.9965,
    r: 0.578571,
    fill: "#FF7900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contactIcon.417f0a4f047721f5446bd6e4b3da52bf.svg";
export { ForwardRef as ReactComponent };